import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, breadcrumbList, faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { ServicesContent } from "@/components/ServicesContent";

export const Route = createFileRoute("/services/")({
  head: () => ({
    meta: [
      { title: "ISO Preparation & Supplier Registration in Iraq | IraqCert" },
      {
        name: "description",
        content:
          "Review ISO management-system preparation and buyer-specific supplier registration in Iraq. Find the right scope, service and guide for your requirement.",
      },
      {
        property: "og:title",
        content: "ISO Preparation & Supplier Registration in Iraq | IraqCert",
      },
      {
        property: "og:description",
        content:
          "Review ISO management-system preparation and buyer-specific supplier registration in Iraq. Find the right scope, service and guide for your requirement.",
      },
      { property: "og:url", content: absolute("/services") },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/services") }, ...hreflangLinks("/services")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          graph(
            breadcrumbList([
              { name: "Home", path: "/" },
              { name: "Services", path: "/services" },
            ]),
            faqPage(
              "/services",
              content.faq.servicesHub.map((f) => ({ q: f.q.en, a: f.a.en })),
            ),
          ),
        ),
      },
    ],
  }),
  component: ServicesContent,
});
